import React from 'react';
import './App.css';
import Auth from './container/Auth';
import {useApolloClient, useQuery} from '@apollo/client';
import {QUERY_USER} from './container/Client/graphql';
import Root from './Root';

const App = () => {
  const client = useApolloClient();

  const query = useQuery(QUERY_USER, {
    fetchPolicy: 'cache-and-network',
    // fetchPolicy: 'network-only',
    onCompleted: data => {
      if (!data || data.user === null || data.user.role !== 'CLIENT') {
        localStorage.removeItem('token@quiz-client');
      }
    },
  });

  const user = query.data ? query.data.user : null;
  const onLogin = token => {
    localStorage.setItem('token@quiz-client', token);
    // query.refetch();
    window.location.reload();
  };

  const onLogout = () => {
    localStorage.removeItem('token@quiz-client');
    client.cache.writeQuery({query: QUERY_USER, data: {user: null}});
  };

  if (!query.called || (!query.data && query.loading)) {
    return <div className="h-100 row align-items-center justify-content-center text-primary">Загрузка...</div>;
  }
  if (!query.data || !user || (user && user.role !== 'CLIENT')) {
    return <Auth onLogin={onLogin} user={user} userLoading={query.loading} />;
  }

  return <Root onLogout={onLogout} />;
};

export default App;
